import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      minHeight: '0',
      display: 'flex',
      flexDirection: 'column',

      flex: 1,

      '& > div:first-child': {
        height: '100%',
        minHeight: '0',
        overflowY: 'auto',

        '& > div': {
          height: '100%',
          overflowY: 'auto',

          '& .MuiTypography-h4': {
            color: theme.palette.text.secondary,
            fontWeight: 500,
            margin: theme.spacing(1, 0, 2, 0),
          },
        },
      },
    },
    container: {
      width: '100%',
      padding: theme.spacing(2, 0, 3),

      '& .MuiFormControl-root': {
        width: '100%',
        margin: 0,
      },

      '& .MuiGrid-item': {
        paddingRight: 0,
      },

      '& .MuiGrid-spacing-xs-1': {
        margin: 0,
      },
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '1rem 0',

      '& button': {
        width: 'auto',
        height: 'auto',
        margin: '0',
        padding: '1rem 1.5rem',
        minWidth: '10rem',
      },
    },
  }),
)
